module.exports = __webpack_public_path__ + "static/media/FacilitiesRec.8ff499cd.jpg";